import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { LockKeyhole, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import VstMakerPreview from "./VstMakerPreview";

export default function VstMakerAccess() {
  const { loading: authLoading, isCustomer } = useAuth();
  const [entitlement, setEntitlement] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isCustomer) { setLoading(false); return; }
    api.get("/customer/vst-maker/entitlements")
      .then(({ data }) => setEntitlement(data))
      .finally(() => setLoading(false));
  }, [isCustomer]);

  if (authLoading || loading) return <div className="min-h-screen pt-40 text-center text-zinc-500"><Loader2 className="mx-auto mb-3 h-6 w-6 animate-spin" />Menyiapkan VST Studio…</div>;
  if (!isCustomer) return <Navigate to="/login?next=/vst-studio" replace />;
  if (!entitlement?.active) return (
    <div className="min-h-screen px-6 pb-24 pt-32">
      <div className="mx-auto max-w-xl rounded-3xl border border-white/10 bg-[#0a0a0c] p-8 text-center">
        <LockKeyhole className="mx-auto h-10 w-10 text-[#fb7185]" />
        <h1 className="mt-5 font-[Outfit] text-3xl font-black">VST Studio belum tersedia</h1>
        <p className="mt-3 text-sm leading-6 text-zinc-400">Muat ulang sesi customer Anda atau hubungi dukungan. VST Studio tidak lagi memerlukan paket langganan.</p>
        <Link to="/vst-maker/billing" className="mt-6 inline-flex rounded-full bg-[#e11d48] px-6 py-3 text-sm font-bold text-white hover:bg-[#be123c]">Lihat paket & hak distribusi</Link>
      </div>
    </div>
  );
  return <VstMakerPreview customerMode entitlement={entitlement} />;
}
